import type {ReactAction} from '@netx/core/bootstrap';
import {faTimes} from '@fortawesome/pro-solid-svg-icons';
import {currentCartIsNotEmpty} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Empty cart
 * @param params
 * @returns Action
 */
export const cartActionEmpty = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-empty',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.EMPTY),
	enableTest: currentCartIsNotEmpty,
	icon: faTimes,
	get label() {
		return CART_CURRENT_ACTION_LABELS.EMPTY;
	},
	...params,
});

export default cartActionEmpty;
